import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import * as Model from './index.model';
import * as ApiConfig from '../core/apiconfig';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()

export class ComplaintService {
    private apiUrl: string;
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = ApiConfig.API_URL + ApiConfig.API_HouseCheck;
    }

    CreateOtherComplaint(model: Model.CitService) {        
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http.post(this.apiUrl + "/" + ApiConfig.API_OtherComplaints, body, this.Http_Header_Request_Options)
            .toPromise().then(data => { return data.json() as Model.CitService; });
    }

    // Get  the Complaits History based on citServiceId to Api Start
    ViewComplaintHistory(CitServiceId: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http
            .get(this.apiUrl + "/" + ApiConfig.API_HouseCheckHistory + "/" + CitServiceId, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }

    // Get  the HouseCheck History based on nameID to Api Start
    ViewTaxiComplaintHistorybynameID(nameID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http
            .get(this.apiUrl + "/" + ApiConfig.API_HouseCheckHistoryByNameID + "/" + nameID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Model.CitService;
            })
            .catch(this.handleError);
    }

    GetCitizenAddressInfo(citizenID: string) {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        return this._http
            .get(ApiConfig.API_URL + ApiConfig.API_Citizen + "/" + citizenID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json()[0];
            })
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/services/complaints.service.ts